import React from "react";

class ElementList extends React.Component {

    static defaultProps = {
        elements: null
    };

    getRenderItem = elementList => {
        if ( Array.isArray(elementList) ) {
            return this.renderArray(elementList);
        }
        else if(typeof elementList === 'object') {
            return this.renderObject(elementList);
        }

        return null;
    }

    render() {

        let { elements } = this.props;

        if (!elements) { return null; }


         return (
             <div>
                 <table className="table table-hover table-borderless" > 
                     <tbody>
                         <tr></tr>
                         { this.getRenderItem(elements) }
                     </tbody>
                 </table>
             </div>
         )
    }

    

    renderArray = (elementList) => {
        return (
            elementList.map(element => {
                return (
                    <tr key={element.key}>
                        <th className='text-black-50'>{element.key}</th>
                        <td className='text-secondary text-left'>{element.value}</td>
                    </tr>
                );
            })
        );
    }

    renderObject = (elementList) => {
        let keyList = Object.keys(elementList);
        return (
            keyList.map( key => {
                return (
                    <tr key={key}>
                        <th className='text-black-50'>{key}</th>
                        <td className='text-secondary text-left'>{JSON.stringify(elementList[key])}</td>
                    </tr>
                );
            })
        );
    }

}

function renderReport( elements, containerClass) {
    if (!elements) {
        return null;
    }
    return (<div className={containerClass}> <ElementList elements={elements} /> </div>);
    
}

export default ElementList;

export { ElementList, renderReport }